import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../api/axiosInstance";

const API_URL = `/api/v1/Amenity`;

// CREATE Amenity
export const createAmenity = createAsyncThunk(
  "amenity/createAmenity",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(API_URL, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to create amenity");
    }
  }
);

// GET all amenities
export const getAmenities = createAsyncThunk(
  "amenity/getAmenities",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(API_URL);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch amenities");
    }
  }
);

// GET single amenity by ID
export const getAmenityById = createAsyncThunk(
  "amenity/getAmenityById",
  async (id, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_URL}/${id}`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch amenity");
    }
  }
);

// UPDATE amenity
export const updateAmenity = createAsyncThunk(
  "amenity/updateAmenity",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${API_URL}/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to update amenity");
    }
  }
);

// DELETE amenity
export const deleteAmenity = createAsyncThunk(
  "amenity/deleteAmenity",
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${API_URL}/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to delete amenity");
    }
  }
);

const amenitySlice = createSlice({
  name: "amenity",
  initialState: {
    amenities: [],
    amenity: null,
    loading: false,
    error: null,
    success: null,
  },
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE
      .addCase(createAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities.push(action.payload);
        state.success = "Amenity created successfully.";
      })
      .addCase(createAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // READ
      .addCase(getAmenities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAmenities.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities = action.payload;
      })
      .addCase(getAmenities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities = state.amenities.map((item) =>
          item._id === action.payload._id ? action.payload : item
        );
        state.success = "Amenity updated successfully.";
      })
      .addCase(updateAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // DELETE
      .addCase(deleteAmenity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAmenity.fulfilled, (state, action) => {
        state.loading = false;
        state.amenities = state.amenities.filter(
          (item) => item._id !== action.payload
        );
        state.success = "Amenity deleted successfully.";
      })
      .addCase(deleteAmenity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
       // Get Amenity By ID
       .addCase(getAmenityById.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.amenity = null;
      })
      .addCase(getAmenityById.fulfilled, (state, action) => {
        state.loading = false;
        state.amenity = action.payload;
      })
      .addCase(getAmenityById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMessages } = amenitySlice.actions;
export default amenitySlice.reducer;
